import React from "react";
import { Box, Typography } from "@mui/material";
import { keyframes } from "@mui/system";

const bounce = keyframes`
  0%, 80%, 100% { transform: scaleY(0.4); }
  40% { transform: scaleY(1.0); }
`;

const BAR_COUNT = 5;
const COLORS = ["#7c3aed", "#8b5cf6", "#a78bfa", "#8b5cf6", "#7c3aed"];

function PersonalizationLoader() {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#0f0f0f",
        gap: 3,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "6px",
          height: 48,
        }}
      >
        {Array.from({ length: BAR_COUNT }).map((_, i) => (
          <Box
            key={i}
            sx={{
              width: 8,
              height: 36,
              borderRadius: 1,
              backgroundColor: COLORS[i],
              animation: `${bounce} 1.2s ease-in-out infinite`,
              animationDelay: `${i * 0.1}s`,
              transformOrigin: "center",
            }}
          />
        ))}
      </Box>
      <Typography
        sx={{
          color: "#d4d4d4",
          fontSize: { xs: 14, md: 16 },
          fontWeight: 500,
          letterSpacing: 0.5,
        }}
      >
        Perfecting your personalization
      </Typography>
    </Box>
  );
}

export default PersonalizationLoader;
